import React from "react";
import { AppSectionCard } from "components/common/cards";

export default function SectionCard(props) {
  return <AppSectionCard className="subcontract-section-card" {...props} />;
}
